"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceTypesStyleMap = void 0;
var styles = require("../DeviceLine/DeviceLine.scss");
exports.DeviceTypesStyleMap = new Map([
    ['PHONES', styles.mobilesmartphone],
    ['TABLETS', styles.tablets],
    ['WEARABLES', styles.wearables],
]);
//# sourceMappingURL=DeviceLineProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/wireless-ui/components/DeviceCountPanel/DeviceLine/DeviceLineProps.js
// module id = 1725
// module chunks = 8